import messages from './messages';
import { StateProgramSetup } from '../StateProgramSetup';
import PropertyStateConfig from '../../../PropertyStateConfig';

const StLouisFundsSetup = ({
  editMode,
  onChange,
  values,
  promptToaster,
  isLoadingPassbookRateData,
  state,
  stateConfigs,
}: Props) => {
  const StLouisFundsConfig = {
    programName: 'StLouisFunds',
    titleMessage: messages.title,
    showInterimCerts: true,
    showOverrideQualification: true,
    showAnnualRecertMonth: true,
  };

  return (
    <>
      <StateProgramSetup
        editMode={editMode}
        onChange={onChange}
        values={values}
        promptToaster={promptToaster}
        isLoadingPassbookRateData={isLoadingPassbookRateData}
        config={StLouisFundsConfig}
      />

      <PropertyStateConfig
        editMode={editMode}
        onChange={onChange}
        state={state}
        stateConfigs={stateConfigs}
        affordableProgramName={StLouisFundsConfig.programName}
      />
    </>
  );
};

export default StLouisFundsSetup;
